import { Field } from 'formik'
import React from 'react'

import { Checkbox, InfoTooltip } from '@fourthwall/components'

import * as S from './styled'

type CompareAtPriceCheckboxFieldProps = {
  disabled: boolean
  onValueChange?: (value: boolean) => void
}

export const CompareAtPriceCheckboxField = ({
  disabled,
  onValueChange,
}: CompareAtPriceCheckboxFieldProps) => (
  <S.Container>
    <Field
      name="isCompareAtPriceEnabled"
      component={Checkbox}
      label="Add compare-at price"
      disabled={disabled}
      onValueChange={onValueChange}
    />
    <InfoTooltip
      appearance="secondary"
      content={
        <>
          Show off a deal by displaying a higher value with a line through it next to your selling
          price (e.g., $<s>29.99</s>)
        </>
      }
    />
  </S.Container>
)
